import React, { useEffect } from "react";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";

// @mui/material components
import { Dialog, DialogActions, DialogTitle, DialogContent, DialogContentText } from "@mui/material";

// core components
import Button from "components/button/button";
import Loader from '../../configuration/components/loader';

// actions
import { deleteSelection } from "actions/gender/deleteSelection";

function GlobalDeleteDialog(props) {
    const { genders, closeDialog, deleted, loading, isOpen } = props;

    useEffect(() => {
        if (deleted) {
            closeDialog();
        }
    }, [deleted]);

    return (
        <Dialog
            open={isOpen}
            onClose={closeDialog}
            maxWidth={'xs'}
            scroll={'body'}
        >
            <DialogTitle>
                <FormattedMessage id={"gender.global.delete.title"} />
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    <FormattedMessage id={"gender.global.delete.text"} />
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button color={"info"} simple onClick={closeDialog} disabled={loading}>
                    <FormattedMessage id={"gender.delete.cancel"} />
                </Button>
                <Button
                    round
                    color={"danger"}
                    type="submit"
                    disabled={loading}
                    onClick={() => props.deleteSelection(genders)}
                >
                    <FormattedMessage id={"gender.delete.submit"} />
                    {loading && <Loader />}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

const mapStateToProps = state => {
    return {
        loading: state.gender.deleteSelection.loading,
        deleted: state.gender.deleteSelection.deleted,
    }
};

const mapDispatchToProps = dispatch => ({
    deleteSelection: (genders) => dispatch(deleteSelection(genders)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(GlobalDeleteDialog);
